import Bowser from "bowser";
import { Cmd, Command } from '../utils/cmd';
window.bowser = Bowser.getParser(window.navigator.userAgent);
window.MEUIKitCMD = window.MEUIKitCMD || [];

// Load Fontawesome
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = String(new URL(
  '/assets/fonts/fontawesome-free-6-2-1/css/all.min.css',
  import.meta.url.includes('/@fs/') || import.meta.url.startsWith('file://')
    ? (new URL('/', window.location.href))
    : import.meta.url,
));
document.head.appendChild(link);

/**
 * Runs once before MEUIKit loads
 *
 * @see https://stenciljs.com/docs/config#globalscript
 */
export default async function () {
  /**
   * Runs once when MEUIKit and all of its child components have finished loading
   *
   * @see https://stenciljs.com/docs/api#the-appload-event
   */
  function handleAppLoad(event: CustomEvent) {
    if (event.detail?.namespace !== 'meuikit') { return; }

    window.removeEventListener('appload', handleAppLoad);

    window.MEUIKitCMD = new Cmd(window.MEUIKitCMD as Command[]);
  }

  window.addEventListener('appload', handleAppLoad);

  /**
   * Forwards clicks to a desired element using data attributes
   *
   * Add `data-me-forward-click="css selector"` to any element to forward click events.
   * Optionally forward clicks conditionally using the `data-me-forward-click-if="function"` attribute.
   */
  window.addEventListener('click', (event) => {
    if (!(event.target instanceof HTMLElement)) { return; }

    const forwarder = event.target.closest(`[data-me-forward-click]`);

    if (!(forwarder instanceof HTMLElement)) { return; }

    const target = forwarder.querySelector(forwarder.dataset.meForwardClick);

    if (!(target instanceof HTMLElement)) { return; }

    const shouldForward =
      target !== event.target // prevent endless loop
      && (
        !('meForwardClickIf' in forwarder.dataset)
        || Boolean(window[forwarder.dataset.meForwardClickIf]?.call())
      );

    if (shouldForward) {
      target.click();
    }
  });
}
